import axios  from 'axios'

const AUTH_SERVICE_URI = process.env.AUTH_SERVICE_URI

interface BridgeProfileValidationResponse {
  isAdminWithBridgeSubscription?: boolean
  isMemberWithBridgeSubscription?: boolean
  redirectToMarketingPage?: boolean
}

export async function isValidBridgeSubscription(): Promise<BridgeProfileValidationResponse> {
  const method = 'get'
  const url = `${AUTH_SERVICE_URI}/api/bridge-validation`
  const headers = {
    Accept: 'application/json'
  }
  const { data } = await axios(url, { headers, method, withCredentials: true })

  return data
}
